module.exports = __webpack_public_path__ + "img/89.87433770.png";